import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ToastAlert, { ToastCloseIcon } from "../ToastAlert/ToastAlert.jsx";
import LoadingScreen from "../SSORequestAccountForm/components/LoadingScreen.jsx";
import PageBanner from "../PageBanner/PageBanner.jsx";
import ContainerBleed from "../Container/ContainerBleed.jsx";
import ContainerFull from "../Container/ContainerFull.jsx";

const SHARED_TOAST_DEFAULTS = {
  className: "st-toast-alert",
  hideProgressBar: true,
  position: "bottom-right",
  closeButton: <ToastCloseIcon />,
};
const SSOBulkUpload = () => {
  const [loading, setLoading] = useState(false);

  const downloadCSVTemplate = e => {
    e.preventDefault();
    // Logic to download the CSV template
    const csvContent =
      "data:text/csv;charset=utf-8,OutputStatus,Note,FirstName,LastName,Email,OfficePhone,MobilePhone,City,State,ZipCode,CompanyName,BusinessLine,DoingBusinessIn,StewartContact,StewartContactEmail,NewsLetterSignUp,SMSMessageConsent,JobTitle,Status\n,,John,Doe,john.doe@example.com,(555) 123-4567,(555) 987-6543,New York,NY,10001,Acme Corp,Title Insurance,NY;NJ,Jane Smith,jane.smith@stewart.com,TRUE,FALSE,Senior Underwriter,Active";
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "sso_account_template.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
  };

  const uploadCSV = e => {
    e.preventDefault();
    // Function to handle CSV upload
    const fileInput = e.target.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    if (file) {
      console.log("Uploading CSV file:", file.name);
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);

      fetch("/sitecore/shell/B2C/AdminManagement/ImportAzureB2CCsv", {
        method: "POST",
        body: formData,
      })
        .then(response => {
          setLoading(false);
          if (response.status === 415) {
            toast(
              <ToastAlert
                style="error"
                title="Unsupported Media Type"
                description="The file format is not supported. Please upload a CSV file."
              />,
              SHARED_TOAST_DEFAULTS,
            );
          } else if (response.status === 400) {
            return response.json().then(data => {
              const errorMessage =
                data?.Message ||
                "The file is invalid. Please verify and try again.";
              toast(
                <ToastAlert
                  style="error"
                  title="Invalid File"
                  description={errorMessage}
                />,
                SHARED_TOAST_DEFAULTS,
              );
            });
          } else if (response.status === 500) {
            return response.json().then(data => {
              const errorMessage =
                data?.message ||
                "A server error occurred while processing the file.";
              toast(
                <ToastAlert
                  style="error"
                  title="Server Error"
                  description={errorMessage}
                />,
                SHARED_TOAST_DEFAULTS,
              );
            });
          } else if (response.status === 200) {
            return response.json().then(data => {
              const successMessage =
                data?.message || "CSV file uploaded successfully.";
              toast(
                <ToastAlert
                  style="success"
                  title="Success"
                  description={successMessage}
                />,
                SHARED_TOAST_DEFAULTS,
              );
              fileInput.value = "";
            });
          } else {
            throw new Error("Failed to upload CSV file");
          }
        })
        .catch(error => {
          setLoading(false);
          console.error("Upload error:", error);
          toast(
            <ToastAlert
              style="error"
              title="Upload Failed"
              description="Unable to upload CSV file. Please try again."
            />,
            SHARED_TOAST_DEFAULTS,
          );
        });
    } else {
      toast(
        <ToastAlert
          style="error"
          title="No File Selected"
          description="Please select a CSV file to upload."
        />,
        SHARED_TOAST_DEFAULTS,
      );
    }
  };

  useEffect(() => {
    // this component exists on its own separate .aspx page
    // we need it to inherit VU styles, so we add the theme to body outselves
    document.body.classList.add("theme-vu");
  }, []);

  return (
    <>
      {loading && <LoadingScreen />}
      <ContainerBleed backgroundColor="#f2f2f2">
        <PageBanner
          darkText={true}
          showAccentLine={true}
          title="Account Approval"
        />
      </ContainerBleed>
      <ContainerFull style={{ paddingBlock: "4rem" }}>
        <div className="sso-account-approval__csv-upload">
          <form
            className="sso-account-approval__csv-upload-form"
            onSubmit={uploadCSV}
          >
            <h3>Import Users</h3>
            <div>
              <p>
                Click below to upload a .csv file to create users or modify
                existing users' statuses.{" "}
              </p>
              <p>
                Please see this{" "}
                <a href="#" onClick={downloadCSVTemplate}>
                  template
                </a>{" "}
                to ensure proper formatting.
              </p>
              <p>Prerequisites:</p>
              <ol>
                <li>
                  Must include a status of ACTIVE, INACTIVE, or REJECTED in the
                  Status column
                </li>
                <li>
                  Must include TRUE or FALSE in the NewsLetterSignUp and
                  SMSMessageConsent columns
                </li>
                <li>Cannot upload more than 500 users at a time</li>
              </ol>
            </div>
            <input type="file" accept=".csv" placeholder="Select CSV file" />
            <button className="btn btn--primary">Upload CSV</button>
          </form>
        </div>
        <ToastContainer autoClose={false} />
      </ContainerFull>
    </>
  );
};

export default SSOBulkUpload;
